import { useEffect, useState } from "react";
import api, { fmtINR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ReminderBanner } from "@/pages/PurchaseReminders";

export default function Pending({ mode /* orders | purchase */ }) {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const type = mode === "orders" ? "sale,estimate,proforma" : "purchase";
      const { data } = await api.get(`/txns?txn_type=${type}&limit=1000`);
      setRows(data.filter((r) => r.balance > 0));
      if (mode === "purchase") {
        const it = await api.get("/items/alerts/reorder");
        setItems(it.data);
      }
    })();
  }, [mode]);

  return (
    <div>
      <div className="overline">{mode === "orders" ? "Pending Orders" : "Pending Purchases"}</div>
      <h1 className="text-3xl font-bold tracking-tight mb-6">{mode === "orders" ? "Sales with balance due" : "Purchases with balance due & reorder items"}</h1>

      {mode === "purchase" && <ReminderBanner />}
      {mode === "purchase" && items.length > 0 && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <div className="flex items-center gap-2 mb-2"><AlertTriangle size={16} className="text-amber-700" /><span className="overline text-amber-800">Items at reorder level</span></div>
          <div className="grid md:grid-cols-3 gap-3">
            {items.map((it) => (
              <div key={it._id_str} className="border border-amber-200 rounded p-3 bg-white">
                <div className="font-semibold">{it.name}</div>
                <div className="text-xs text-slate-500">Stock {it.stock} · Reorder {it.reorder_level}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="bg-white border border-border rounded-lg overflow-x-auto">
        <table className="acc-table w-full">
          <thead><tr><th>Date</th><th>Number</th><th>Party</th><th className="num">Total</th><th className="num">Paid</th><th className="num">Balance</th><th className="num">Credit Days</th><th></th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8} className="text-center py-6 text-muted-foreground">Nothing pending. Great!</td></tr>}
            {rows.map((r) => (
              <tr key={r._id_str}>
                <td>{new Date(r.date).toLocaleDateString()}</td>
                <td className="font-mono">{r.number}</td>
                <td>{r.party_name}</td>
                <td className="num">{fmtINR(r.total)}</td>
                <td className="num">{fmtINR(r.paid)}</td>
                <td className="num text-[#991B1B] font-bold">{fmtINR(r.balance)}</td>
                <td className="num">{r.credit_period_days || 0}d</td>
                <td><Button size="sm" variant="outline" onClick={() => window.open(`/print/txn/${r._id_str}`, "_blank")}>Print</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
